/*
 * Sends browser crashes to the server's error log (POST /api/client-errors),
 * where they sit next to server errors on the Debug page and in the debug
 * loop's report. Deliberately tiny and failure-proof.
 */
const seen = new Set<string>();

export function reportError(kind: string, message: string, stack?: string, extra?: Record<string, unknown>) {
  const key = `${kind}|${message}`;
  if (seen.has(key) || seen.size > 25) return;
  seen.add(key);
  try {
    void fetch('/api/client-errors', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ kind, message, stack, url: location.href, extra }),
      keepalive: true,
    }).catch(() => undefined);
  } catch {
    /* never let reporting throw */
  }
}

export function installErrorReporter() {
  window.addEventListener('error', (event) => {
    // Resource load failures bubble as plain Events without a message.
    if (!event.message) return;
    reportError('window.onerror', event.message, event.error?.stack, { source: event.filename, line: event.lineno, column: event.colno });
  });
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    const message = reason instanceof Error ? reason.message : String(reason);
    // Expected API failures are surfaced in the UI already.
    if (reason && typeof reason === 'object' && 'status' in reason) return;
    reportError('unhandledrejection', message, reason instanceof Error ? reason.stack : undefined);
  });
}
